import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
import { getQueryString } from '@/utils/common'
export const querySqpMainPage = async (params: object) => {
  return await GET({
    url: Api.querySqpMainPage,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
